import { Box, Flex, Text } from '@mantine/core'

import { useCoinContext } from '@/app/[locale]/price/[slug]/_contexts/CoinContext'
import AnimatedPrice from '@/components/AnimatedPrice'
import { btcPriceFormat } from '@/utils/number'

import { formatChangePercent, getPercentChangeColor } from '../utils'

interface ChartInfoTitleProps {
  coinPrice?: number
  coinPercentChange?: number
  btcPrice?: number
  isMouseInChart: boolean
}

export default function ChartInfoTitle({
  coinPrice,
  coinPercentChange,
  btcPrice,
  isMouseInChart,
}: ChartInfoTitleProps) {
  const { coin } = useCoinContext()
  const changeColor = getPercentChangeColor(coinPercentChange ?? 0)
  const changeText = coinPercentChange ? formatChangePercent(coinPercentChange * 100) : void 0
  return (
    <Box>
      <Flex h={40}>
        <AnimatedPrice
          // to prevent when mouse out of chart would have a price animate
          key={`${isMouseInChart}`}
          variant={'balances'}
          flex={1}
          price={coinPrice}
          tokenSymbol={coin.symbol}
          disabledPriceAnimate={isMouseInChart}
          // when mouse inchart, would use the data in line chart api
          // the origin data was converted, not need converted again
          disabledConvert={isMouseInChart}
        />
        <Text variant={'body'} c={'var(--content-secondary)'}>
          {btcPrice ? `${btcPriceFormat(btcPrice)} BTC` : ''}
        </Text>
      </Flex>
      <Box h={20}>
        <Text c={changeColor} variant={'body'}>
          {changeText}
        </Text>
      </Box>
    </Box>
  )
}
